// Assistance côté enseignant et administrateur (maquette enseignant.html) : file d'attente des
// élèves, indicateurs calculés par le serveur, disponibilité, et conversations avec tout le
// compositeur existant. La messagerie (onglet « Messages ») reste réservée aux échanges internes.
import React, { useCallback, useEffect, useState } from "react";
import api from "../../services/api";
import { qlAlert } from "../../utils/dialogs";
import MessagesView from "../MessagesView";
import "./Assistance.css";

function Indicateur({ libelle, valeur, detail, ton }) {
  return (
    <div className="qas-kpi" style={{ "--qas-ton": ton }}>
      <span>{libelle}</span>
      <strong>{valeur}</strong>
      <small>{detail}</small>
    </div>
  );
}

export default function AssistanceEnseignant({ user, exercices = null }) {
  const [tableau, setTableau] = useState(null);
  const [vue, setVue] = useState("file");
  const charger = useCallback(() => {
    api.get("assistance/tableau/").then((r) => setTableau(r.data)).catch(() => setTableau((t) => t || false));
  }, []);
  useEffect(() => {
    charger();
    const t = setInterval(charger, 30000);
    return () => clearInterval(t);
  }, [charger]);
  const changerDisponibilite = (modif) => {
    const suivante = { ...tableau.disponibilite, ...modif };
    api.put("assistance/disponibilite/", suivante)
      .then((r) => setTableau((t) => ({ ...t, disponibilite: { statut: r.data.statut, capacite: r.data.capacite } })))
      .catch((err) => qlAlert(err.response?.data?.detail || "Modification impossible.", "error"));
  };
  const d = tableau?.disponibilite;
  return (
    <div className="qas-prof">
      <div className="qas-prof-entete">
        <div>
          <h1>Assistance · élèves</h1>
          <p>Questions des élèves, rendus de devoirs et d'évaluations : gérez les demandes qui vous sont adressées.</p>
        </div>
        {d && (
          <div className={`qas-dispo qas-dispo--${d.statut}`}>
            <label>
              <span className="qas-dispo-point">●</span>
              <select aria-label="Ma disponibilité" value={d.statut} onChange={(e) => changerDisponibilite({ statut: e.target.value })}>
                {tableau.statuts.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            </label>
            <label className="qas-capacite" title="Nombre d'élèves suivis en même temps">
              <i className="bi bi-people"></i>
              <select aria-label="Élèves suivis en même temps" value={d.capacite} onChange={(e) => changerDisponibilite({ capacite: Number(e.target.value) })}>
                {[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>{n} à la fois</option>)}
              </select>
            </label>
          </div>
        )}
      </div>
      {tableau && (
        <div className="qas-kpis">
          <Indicateur libelle="Demandes en attente" valeur={tableau.en_attente} detail="Dans votre file" ton="#c58f00" />
          <Indicateur libelle="Demandes en cours" valeur={tableau.en_cours} detail="Prises en charge" ton="#1262ef" />
          <Indicateur libelle="Messages non lus" valeur={tableau.non_lus} detail="Des élèves" ton="#e64049" />
          <Indicateur libelle="Temps médian de traitement" valeur={tableau.duree_mediane != null ? `≈ ${tableau.duree_mediane} min` : "—"}
            detail={tableau.duree_mediane != null ? "Sur vos demandes terminées" : "Pas encore assez de demandes terminées"} ton="#08255d" />
        </div>
      )}
      {exercices && (
        <div className="qas-onglets" role="tablist">
          <button role="tab" aria-selected={vue === "file"} className={vue === "file" ? "active" : ""} onClick={() => setVue("file")}>
            <i className="bi bi-chat-square-text me-1"></i>File et conversations</button>
          <button role="tab" aria-selected={vue === "exercices"} className={vue === "exercices" ? "active" : ""} onClick={() => setVue("exercices")}>
            <i className="bi bi-question-circle me-1"></i>Demandes sur les exercices</button>
        </div>
      )}
      {vue === "file" || !exercices ? (
        <div className="qas-prof-conversations">
          <MessagesView user={user} compact perimetre="assistance" titre="Assistance" libelleNouveau="Écrire à un élève" onChange={charger} />
        </div>
      ) : exercices}
    </div>
  );
}
